import React from "react";
import Social from "./Social";

const Home = () => {
  return (
    <>
      <div className="tokyo_tm_home">
        <div className="home_content">
          <div className="avatar">
            <div
              className="image avatar_img"
              style={{
                backgroundImage: "url(assets/img/slider/1.jpg)",
              }}
            ></div>
            {/* END AVATAR IMAGE */}
          </div>
          {/* END AVATAR */}
          <div className="details">
            <h3 className="name">Daisuke Nashiro</h3>
            <p className="job">
              ようこそnashirox.devへ。このサイトは、東京在住ソフトウェアエンジニアのポートフォリオサイトです。開発したアプリケーションの紹介はもちろんですが、ちょっとした実験場でもあります。現在はReact / Netlify / headless CMSを使って構築しています。
            </p>
            {/* END JOB */}
            <Social />
          </div>
          {/* END DETAILS */}
        </div>
        {/* END HOME CONTENT */}
      </div>
      {/* END HOME */}
    </>
  );
};

export default Home;
